module.exports = __webpack_public_path__ + "static/media/file-notes.2d0a54c0.svg";